import { QuizAssessment } from '../Stage';
import { useLocalization } from '~/framework';
import { CircularProgress } from '@chakra-ui/react';
import { Card, CardProps, CardContent, CardHeader } from '~/ui-components';

type QuizCardProps = CardProps & {
   quiz: QuizAssessment;
};

export function QuizCard({ quiz, ...props }: QuizCardProps) {
   const { _js } = useLocalization();

   return (
      <Card minHeight="112.5px" aria-label={_js('Quiz Card')} {...props}>
         <CardContent ml={4} mr={4} width="100%">
            <CardHeader>
               {quiz ? quiz.title : <CircularProgress size="16px" isIndeterminate />}
            </CardHeader>
         </CardContent>
      </Card>
   );
}
